import { http } from "@/lib/http";
export function fetchUsers() {
  return http.get("/users/get_all").then((res) => res.data);
}
export function fetchUser(id) {
  return http.get(`/users/get/${id}`).then((res) => res.data);
}
export function deleteUser(id) {
  return http.delete(`/users/delete/${id}`).then((res) => res.data);
}
export function saveUser(user) {
  return http.post("/users/update_add_user", user).then((res) => res.data);
}
export function addUserPoints({ customer_id, points }) {
  return http
    .post("/users/add_points", { customer_id, points })
    .then((res) => res.data);
}
export function autoCreateTasks(userGuids) {
  return http
    .post("/api/tasks/auto_create_tasks", { userGuids })
    .then((res) => res.data);
}
/**
 * Mirrors Vue2's ResetPassword.vue flow: POST /users/reset-password with
 * { data: customer_id } — there is no per-id reset-password route.
 */
export function resetUserPassword(customerId) {
  return http
    .post("/users/reset-password", { data: customerId })
    .then((res) => res.data);
}
